import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/OG";

// Visuals
import test from "../assets/og/test.png";
import og from "../assets/og/og.png";
import gmc from "../assets/og/gmc.png";

const OasisGardens = () => {
  const project_id = "PRJ00041";
  const title = "The Great Oasis Gardens - Nanyuki";

  const mapConfig = {
    minZoom: 3,
    zoom: 3.5,
    bounds: [
      [75.16, -181.45],
      [-39.4, 64.81],
    ],
    imageOverlays: [
        {
          imageUrl: test,
          imageBounds: [
            [-7.12283, -164.37331],
            [-51.34155, -11.44362],
          ],
        },
        {
          imageUrl: og,
          imageBounds: [
            [-29.36902, -23.04518],
            [-39.67152, -7.74049],
          ],
        },
        {
          imageUrl: gmc,
          imageBounds: [
            [1.84985, -162.04518],
            [-3.67152, -151.74049],
          ],
        },
      ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/the-great-oasis-gardens-nanyuki/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSfkovo3n5xt2iggBTQeHIaa98TI6-XbUXTPeTBc2XoGLdRwOg/viewform"
    />
  );
};

export default OasisGardens;
